import React, { Component } from 'react'
import { HashRouter, Link } from 'react-router-dom'
import { setRegPage, currentWidget, popupOpenClose, setDeviceConfigFailed, setMobileTVPage, setFailScreen, openSMSWidget, setOpenProfileImage } from '../../action/action'
import { connect } from 'react-redux'
import { nonCompWidgetClick } from '../../layout2.0/JS/widgetHandling'
import { setRoomControlPage } from '../../layout2.0/action/action'
import { setOpenDemoCamera, setGoHome, setLoader, setLoginRequired, setExternalSignIn, setDNDon, setMURon } from '../../layout2.0/action/homeAction'
import { closeOrderPopUp } from '../../layout2.0/action/hCommerce2'
import { setHcommerceWidget } from '../../layout2.0/action/hCommerce2';
import { sendAnalytics } from "../../action/homeAction"
import { withTranslation } from 'react-i18next'
import { CMSPath } from '../../config/constant'
import { sendAcCommand } from '../../action/roomControlAction'
import { setOpenExternalLinkInSameTab } from '../../layout2.0/action/homeAction'


class FloatingMiddleWidget extends Component {

    constructor(props) {
        super(props);
        this.state = {
            widgetData: {}
        }
    }

    componentDidMount() {
        if (this.props.widgetList.length > 0) {
            this.setState({ widgetData: this.props.widgetList[0] })
        }
    }
    componentDidUpdate(preProb) {
        if (preProb.widgetList !== this.props.widgetList && this.props.widgetList.length > 0) {
            this.setState({ widgetData: this.props.widgetList[0] })
        }
    }
    setRoomControlPageOnClick = (widget) => {
        switch (widget.widgetType) {
            case "Room Theme":
                this.props.setRoomControlPage("roomTheme");
                break;
            case "Room Temperature":
                this.props.setRoomControlPage("AcControl");
                break;
            case "Speaker":
                this.props.setRoomControlPage("speakerControl");
                break;
            case "Smart Window Control":
                this.props.setRoomControlPage("windowTintControl");
                break;
            default:
                console.log("no room control path is matching.")
                break;
        }
    }

    onWidgetClick = async (widget) => {
        let room = localStorage.getItem('room')
        console.log("current widget", widget)
        if (widget.path) {
            await this.props.currentWidget(widget);
            if (widget.path === "/RoomControl2") {
                this.setRoomControlPageOnClick(widget);
            }
            if (widget.path === "/mobileTv") {
                if (!room) {
                    if (process.env.REACT_APP_INROOMTAB == "true") {
                        this.props.setLoginRequired(true)
                    } else {
                        this.props.setRegPage(true);
                    }
                } else {
                    this.props.setMobileTVPage(true);
                }

            }
            if (widget.path === "/happy") {
                if (this.props.survey.needsLogin)
                    if (!room || room === "null") {
                        if (process.env.REACT_APP_INROOMTAB == "true") {
                            this.props.setLoginRequired(true)
                        } else {
                            this.props.setRegPage(true);
                        }
                    }
            }
            if (widget.widgetType === "Hcommerce") {
                this.props.setHcommerceWidget(widget);
            }
        } else {
            nonCompWidgetClick(widget, this.props)
        }
    }

    render() {
        console.log()
        return (
            <div>
                <Link
                    exact to={this.state.widgetData.path ? this.state.widgetData.path : "/"}
                    onClick={() => { this.onWidgetClick(this.state.widgetData) }}
                    className="tile-container"
                    style={{backgroundColor: this.props.menuColor.assetBackgroundSelectorColor}}>
                        { this.state.widgetData.btnImageUrl ?
                            <span class="button-icon">
                                <img src={`${CMSPath}${this.state.widgetData.btnImageUrl}`} />
                            </span> 
                            : <i class="fas fa-calendar"></i>
                        }
                        {this.props.floatingWidgetRenderType == "BOTTOM_DOCKED" && <span class="button-icon">{this.state.widgetData.displayName}</span>}
                </Link>
            </div>
        )
    }
}

FloatingMiddleWidget.defaultProps = {
    widgetList: []
}

const mapStateToProps = state => {
    return {
        appLauncherWidget: state.store.appLauncher.widget,
        streamingUrlFromConfig: state.store.home.clientConfig.doorCameraFeed ?
            state.store.home.clientConfig.doorCameraFeed.doorCameraFeedUrl : null,
            floatingWidgetRenderType : state.store.home.currentDuration.floatingWidgetRenderType ? state.store.home.currentDuration.floatingWidgetRenderType : null,
        menuColor: state.store.home.MenuColor,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        survey: state.store.survey,
        externalSignIn: state.store2.externalSignIn,
        roomControlSpecificVersion: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs && state.store.home.clientConfig.webAppWidgetsInfo.appConfigs.roomControlSpecificVersion,

    }
}
export default connect(
    mapStateToProps,
    {
        currentWidget,
        popupOpenClose,
        openSMSWidget,
        setDNDon,
        setMURon,
        setOpenProfileImage,
        setRoomControlPage,
        setDeviceConfigFailed,
        setOpenDemoCamera,
        setRegPage,
        sendAcCommand,
        closeOrderPopUp,
        setHcommerceWidget,
        setMobileTVPage,
        sendAnalytics,
        setGoHome,
        setLoader,
        setFailScreen,
        setLoginRequired,
        setOpenExternalLinkInSameTab,
        setExternalSignIn
    }
)(withTranslation('translations')(FloatingMiddleWidget));